import React from "react";
import Banner from "../../../../components/Banner";
import "../../../../assets/styles/career.scss";
import SubjectCards from "./SubjectCards";
import BottomBar from "../../../../components/BottomBar";
import { Bell } from "react-feather";

import { Col, Container, Button, Row } from "reactstrap";

const Elonmusk = () => {
  const handleClick = () => {
    console.log("test");
  };
  return (
    <React.Fragment>
      <Banner
        title="제 2의 일론머스크가 되고 싶다면?"
        bg="physics_banner2.jpg"
      />
      <Container className="subject_container">
        <Row mb={3}>
          <Col md={6} sm={12}>
            <h2>물리학자란?</h2>
            <p>
              물리학자는 단어 그대로 물리라는 학문을 연구하는 과학자를
              의미합니다. 그럼 물리학이란 무엇일까요? 물리학이란 자연과학의 한
              분야로써 우리를 둘러싸고 있는 자연세계의 원리와 법칙들을 연구하는
              학문입니다.
            </p>
          </Col>
          <Col md={6} sm={12}>
            <img
              src={require("../../../../assets/img/physics_explain.jpg")}
              className="horizontal"
              alt="ucas_official"
            />
          </Col>
        </Row>
        <Row mb={3}>
          <Col md={6} sm={12}>
            <h2>기계공학이란?</h2>
            <p>
              기계공학은 인간의 삶을 편리하게 하고 물질적으로 풍요롭게 하기 위해
              힘과 에너지에 대한 연구를 수행하는 학문입니다.
            </p>
          </Col>
          <Col md={6} sm={12}>
            <img
              src={require("../../../../assets/img/mechanical_eng_explain.jpg")}
              className="horizontal"
              alt="ucas_official"
            />
          </Col>
        </Row>
        <hr className="mt-4 mb-4" />

        <div className="compulsory-subjects">
          <Row className="mb-3">
            <Col md={8}>
              <h3 className="heading section-title">수강해야 하는 과목 </h3>
            </Col>
          </Row>
          <Row>
            <Col md={3} className="mb-4">
              <SubjectCards title="Maths" img="maths.png" />
            </Col>
            <Col md={3}>
              <SubjectCards title="Further Maths" img="further_maths.png" />
            </Col>
            <Col md={3}>
              <SubjectCards title="Physics" img="physics.png" />
            </Col>
            <Col md={3} className="mb-4">
              <SubjectCards title="Optional" img="card4.png" />
            </Col>
          </Row>
        </div>
      </Container>
      <BottomBar>
        <Row>
          <Col md={8} sm={12}>
            <div className="d-inline-block">
              <Bell style={{ position: "relative", bottom: "10" }} />
            </div>
            <div className="d-inline-block pl-2">
              <p style={{ fontWeight: "700" }}>
                EARLY BIRD <span style={{ fontWeight: "900" }}>20%</span> 특별
                할인 이벤트!
              </p>
              <p style={{ fontSize: "0.9rem" }}>
                8월 24일 전에 신청하시면 할인 혜택을 받으실수 있습니다.
              </p>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <Button
              color="danger"
              style={{ width: "100%" }}
              onClick={handleClick}
            >
              수강 신청하기
            </Button>
          </Col>
        </Row>
      </BottomBar>
    </React.Fragment>
  );
};

export default Elonmusk;
